import { userColors } from "../data/constants";
import { getCloneObject } from "../helpers";
export function getUsersMap(users) {
    const map = {};
    users = getCloneObject(users);
    for (let index = 0; index < users?.length; index++) {
        const user = users[index];
        user.color = user.color || userColors[index % userColors.length];
        map[user.id] = user;
    }
    return map;
}
export function getAvailableUsers(users, task) {
    const availableUsers = [];
    for (let index = 0; index < task.assigned.length; index++) {
        const user = users[task.assigned[index]];
        user.type = "user";
        if (user)
            availableUsers.push(user);
    }
    return availableUsers;
}
//# sourceMappingURL=user.js.map